import { RedirectConfig } from './redirectMappingsTypes'

export const howToBuyRedirects: RedirectConfig[] = [
  {
    source: /how_to_buy\/.*/,
    destination: `/how-to-buy/`,
    permanent: true,
  },
]
